module.exports = __webpack_public_path__ + "static/Circles-530ffec1fab365cc4cef95774b71e51a.png";